import React from 'react';
import PromotionCard from '../cards/PromotionCard';
import { Col, Row } from 'react-bootstrap';
import {
  UilShoppingCart,
  UilUser,
  UilDollarSign,
  UilPackage
} from '@iconscout/react-unicons';

const EcomPromotionCount = () => {
  return (
    <Row className="g-3">
      <Col xs={6} xl={3}>
        <PromotionCard
          title="Total Orders"
          count={156}
          icon={UilShoppingCart}
          backgroundColor="#E3F2FD"
          borderColor="#C8E6C9"
        />
      </Col>
      <Col xs={6} xl={3}>
        <PromotionCard
          title="Active Users"
          count={2.4}
          icon={UilUser}
          backgroundColor="#E8F5E9"
          borderColor="#C8E6C9"
        />
      </Col>
      <Col xs={6} xl={3}>
        <PromotionCard
          title="Revenue"
          count={45600}
          icon={UilDollarSign}
          backgroundColor="#FFF3E0"
          borderColor="#FFE0B2"
        />
      </Col>
      <Col xs={6} xl={3}>
        <PromotionCard
          title="Products"
          count={89}
          icon={UilPackage}
          backgroundColor="#F3E5F5"
          borderColor="#E1BEE7"
        />
      </Col>
    </Row>
  );
};

export default EcomPromotionCount;
